export const runnerSizes = {
  xs: {
    label: 'Extra Small',
    cpu: 0.25,
    memory: 512, // MB
    displayName: 'Extra Small'
  },
  sm: {
    label: 'Small',
    cpu: 0.25,
    memory: 1024, // MB
    displayName: 'Small'
  },
  md: {
    label: 'Medium',
    cpu: 0.25,
    memory: 2048, // MB
    displayName: 'Medium'
  },
  lg: {
    label: 'Large',
    cpu: 0.5,
    memory: 4096, // MB
    displayName: 'Large'
  },
  xl: {
    label: 'Extra Large',
    cpu: 0.5,
    memory: 4096, // MB
    displayName: 'Extra Large'
  },
  xxl: {
    label: 'Extra Extra Large',
    cpu: 1,
    memory: 8192, // MB
    displayName: 'Extra Extra Large'
  }
};

export const getRunnerSizeDisplay = (size) => {
  if (!size || !runnerSizes[size]) {
    return 'Auto';
  }
  return runnerSizes[size].displayName;
};

export const getRunnerSizeTooltip = (size) => {
  if (!size || !runnerSizes[size]) {
    return 'Automatically assigned runner size';
  }

  const config = runnerSizes[size];
  const cpu = config.cpu === 1 ? '1 CPU' : `${config.cpu} CPUs`;

  let memory;
  if (config.memory < 1024) {
    memory = `${config.memory}MB RAM`;
  } else {
    const gb = config.memory / 1024;
    memory = `${gb === Math.floor(gb) ? gb : gb.toFixed(1)}GB RAM`;
  }

  return `${cpu}, ${memory}`;
};
